"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLog = exports.getDefaultHeaders = exports.consoleType = void 0;
const getDefaultHeaders = token => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: "Bearer ".concat(token)
  }
});
exports.getDefaultHeaders = getDefaultHeaders;
const consoleType = exports.consoleType = {
  error: 'error',
  warning: 'warning',
  log: 'log'
};
const getLog = _ref => {
  let {
    logPrefix,
    hideLogs,
    text,
    type = consoleType.log
  } = _ref;
  if (hideLogs) return;
  // eslint-disable-next-line no-console
  console[type]("".concat(logPrefix).concat(logPrefix ? '::' : '').concat(text));
};
exports.getLog = getLog;